const _ = require('underscore');

// ref: OverDrive.Thunder.Models.DataModels.GeneratedCollectionDetails
module.exports = class GeneratedCollectionDetails {
    constructor() {
        this.mediaType          = '';
        this.language           = '';
        this.publisherEntityId  = null; // int
        this.maturityLevels     = []; // string
        this.subjects           = []; // string

        this.sortBy             = '';
        this.maxItems           = undefined; // int

        Object.assign(this, ...arguments);
    }

    // Translates GeneratedCollectionDetails model to parameters that align with the MediaParameters model for executing a "search"
    serializeForSearch() {
        let model = _.extend({}, this);

        // language is an array in MediaParameters
        model.language = _(_.flatten([model.language])).reject((val) => _.isEmpty(val));

        // maturityLevels is called maturityLevel
        model.maturityLevel = _(_.flatten([model.maturityLevels])).reject((val) => _.isEmpty(val));
        delete model.maturityLevels;

        // subjects is called subject
        model.subject = _(_.flatten([model.subjects])).reject((val) => _.isEmpty(val));
        delete model.subjects;

        return model;
    }
};
